import angular from 'angular';

import { includes } from 'lodash';

const NO_REDIRECT_STATES = [
  'account',
  'offer.account',
  'offer.invitee',
  'offer.login',
  'humans.login',
  'humans.account',
];

module.exports = angular.module('common.services.auth-handler', [])
.factory('AuthHandler', function($q, $injector, $rootScope) {
  return {
    responseError: function(rejection) {
      if ($rootScope.inloginSignupModal) {
        // no-op
        return $q.reject(rejection);
      }
      if ( rejection.status === 401 ) {
        var currentState = $injector.get('$state').$current.name;
        if (!includes(NO_REDIRECT_STATES, currentState)) {
          window.location = '/login';
        }
      }
      return $q.reject(rejection);
    }
  };
})
.config(function($httpProvider) {
  $httpProvider.interceptors.push('AuthHandler');
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/auth-handler.js
 **/